import { years } from "../../login/Login.FirstLogin";

export const OPTION_MENU_REPORT = [
  {
    title: "บันทึกเพิ่มเติม",
    icon: "/images/board_report.png",
    path: "/report",
  },
  {
    title: "ภาพรวมเป้าหมายทางการเงินของคุณ ​",
    icon: "/images/coin-report.png",
    path: "/report/overview",
  },
  {
    title: "สมมติฐานรายงาน",
    icon: "/images/diagram-report.png",
    path: "/report/hypothesis",
  },
  {
    title: "รายรับ",
    icon: "/images/money-report.png",
    path: "/report/income",
  },
  {
    title: "รายจ่าย",
    icon: "/images/expense-report.png",
    path: "/report/expense",
  },
  {
    title: "สินทรัพย์",
    icon: "/images/asset-report.png",
    path: "/report/asset",
  },
  {
    title: "หนี้สิน",
    icon: "/images/debt-report.png",
    path: "/report/debt",
  },
  {
    title: "งบดุล",
    icon: "/images/balance-report.png",
    path: "/report/balance",
  },
  {
    title: "อัตราส่วนทางการเงิน ",
    icon: "/images/financial-analysis-report.png",
    path: "/report/financial",
  },
  {
    title: "แผนบริหารและจัดการความเสี่ยง",
    icon: "/images/risk-report.png",
    path: "/report/riskplan",
  },

  {
    title: "แผนทุนประกันคุ้มครองครอบครัว ",
    icon: "/images/family-report.png",
    path: "/report/familyInsurance",
  },
  {
    title: "แผนทุนประกันทุพพลภาพ",
    icon: "/images/personal-report.png",
    path: "/report/disableInsurance",
  },
  {
    title: "แผนเกษียณ ",
    icon: "/images/grandparents-report.png",
    path: "/report/retirement",
  },
  {
    title: "แผนภาษี",
    icon: "/images/tax-report.png",
    path: "/report/tax",
  },

  {
    title: "สัดส่วนการลงทุน ",
    icon: "/images/revenue-report.png",
    path: "/report/investment",
  },

  {
    title: "แผนการศึกษาบุตร ",
    icon: "/images/graduate-report.png",
    path: "/report/education",
  },
  {
    title: "แผนการออม",
    icon: "/images/savings-report.png",
    path: "/report/savingplan",
  },

  {
    title: "แผนอนาคต",
    icon: "/images/banknote-report.png",
    path: "/report/futureplan",
  },
  {
    title: "วางแผนหนี้สิน",
    icon: "/images/wealth-report.png",
    path: "/report/debtplan",
  },
  {
    title: "แผนมรดก",
    icon: "/images/stakeholders-report.png",
    path: "/report/heritage",
  },
  {
    title: "รวมประกันของคุณ",
    icon: "/images/insurance-all-report.png",
    path: "/report/allInsurance",
  },
];

export const currentYear = new Date().getFullYear();

export const maxYear = currentYear + 100;

export const Education_Price = [
  {
    "type": "เนอสเซอรี่ 1",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "เนอสเซอรี่ 2",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "เนอสเซอรี่ 3",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "อนุบาล 1",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "อนุุบาล 2",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "อนุบาล 3",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 1",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 2",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 3",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 4",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 5",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "ประถมศึกษา 6",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2500000
  },
  {
    "type": "มัธยมศึกษา 1",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2100000
  },
  {
    "type": "มัธยมศึกษา 2",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2100000
  },
  {
    "type": "มัธยมศึกษา 3",
    "government": 60000,
    "private": 220000,
    "international": 920000,
    "overseas": 2100000
  },
  {
    "type": "มัธยมศึกษา 4",
    "government": 60000,
    "private": 220000,
    "international": 960000,
    "overseas": 2100000
  },
  {
    "type": "มัธยมศึกษา 5",
    "government": 60000,
    "private": 220000,
    "international": 960000,
    "overseas": 2100000
  },
  {
    "type": "มัธยมศึกษา 6",
    "government": 60000,
    "private": 220000,
    "international": 960000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาตรี 1",
    "government": 210000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาตรี 2",
    "government": 210000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาตรี 3",
    "government": 210000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาตรี 4",
    "government": 210000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาโท 1",
    "government": 240000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาโท 2",
    "government": 240000,
    "private": 640000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาเอก 1",
    "government": 440000,
    "private": 860000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาเอก 2",
    "government": 440000,
    "private": 860000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาเอก 3",
    "government": 440000,
    "private": 860000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาเอก 4",
    "government": 440000,
    "private": 860000,
    "international": 2100000,
    "overseas": 2100000
  },
  {
    "type": "ปริญญาเอก 5",
    "government": 440000,
    "private": 860000,
    "international": 2100000,
    "overseas": 2100000
  }
]

export const PREMIUM_TIME = { years: 1 }
export const PREMIUM_TRIAL_TIME = { days: 7 }
